import React from 'react';
import { Button } from '@mui/material';

const variantStyles = {
  success: {
    backgroundColor: 'rgba(16, 185, 129, 0.18)',
    color: '#10B981',
    '&:hover': { backgroundColor: 'rgba(16, 185, 129, 0.3)' },
  },
  danger: {
    backgroundColor: 'rgba(239, 68, 68, 0.18)',
    color: '#EF4444',
    '&:hover': { backgroundColor: 'rgba(239, 68, 68, 0.3)' },
  },
  settle: {
    backgroundColor: 'rgba(108, 99, 255, 0.18)',
    color: '#6C63FF',
    '&:hover': { backgroundColor: 'rgba(108, 99, 255, 0.3)' },
  },
  warning: {
    backgroundColor: 'rgba(245, 158, 11, 0.18)',
    color: '#F59E0B',
    '&:hover': { backgroundColor: 'rgba(245, 158, 11, 0.3)' },
  },
  info: {
    backgroundColor: 'rgba(59, 130, 246, 0.18)',
    color: '#3B82F6',
    '&:hover': { backgroundColor: 'rgba(59, 130, 246, 0.3)' },
  },
};

export default function ActionButton({ variant = 'success', onClick, children, disabled, sx, ...rest }) {
  return (
    <Button
      variant="contained"
      color="inherit"
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...variantStyles[variant],
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: '2px',
        px: 2,
        py: 0.5,
        fontSize: '0.85rem',
        boxShadow: 'none',
        '&:hover': {
          ...variantStyles[variant]?.['&:hover'],
          boxShadow: 'none',
        },
        '&.Mui-disabled': {
          backgroundColor: '#2E3247',
          color: '#64748B',
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
